import watchEditGoAMLTemplates from 'app/modules/goAMLSettings/sagas/editGoAMLTemplates';
import watchRetrieveGoAMLTemplates from 'app/modules/goAMLSettings/sagas/retrieveGoAMLTemplates';

const sagaRegistry = [watchEditGoAMLTemplates, watchRetrieveGoAMLTemplates];

export default sagaRegistry;
